import React from "react";
const SvgHpPencil = props => (
  <svg viewBox="0 0 18 18" {...props}>
    <path
      fill="#1A1F24"
      fillRule="evenodd"
      d="M12.64 2.712l1.898 1.898 1.203-1.203-1.899-1.898-1.203 1.203zM2.562 12.789l-.95 2.847 2.848-.949 9.193-9.193-1.899-1.898-9.192 9.193zM.625 17.25a.625.625 0 01-.593-.823l1.392-4.173a.611.611 0 01.151-.245l9.732-9.733a.017.017 0 00.006-.006l.007-.006L13.4.183a.625.625 0 01.884 0l2.783 2.782a.625.625 0 010 .885L5.241 15.676a.628.628 0 01-.245.15L.823 17.217a.618.618 0 01-.198.033z"
    />
  </svg>
);
export default SvgHpPencil;
